import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import dt, { useIsMobile, useIsMobileOrTablet, useIsXXLarge } from '../../../../shared/theme';
import ExpandableContainer from '../../../../shared/expandable-container';

const Container = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font: ${props => dt(props).theme.fontWeightRegular} 16px/130% ${props => dt(props).theme.fontFamilyBody};
  margin-top: 12px;

  a, b {
    font-weight: ${props => dt(props).theme.fontWeightBold}
  }

  & > .readmore-container {
    p {
      line-height: unset;
      margin-bottom: 0;
    }

    & > .showless {
      display: none;
    }
  }
`;

const buildComponentToShow = (
  fundId,
  methodology,
  pdsFileUrl,
  lines,
) => {
  const handlePDSClick = () => recordStatisticsEvent({
    event: 'fund_profile_pds_clicked',
    statisticable: 'fund',
    id: fundId,
    clicked_url: pdsFileUrl,
    page: `${window.location.pathname}#fund-fees`,
  });

  const placeholder = (
    <>
      View the&nbsp;
      {!pdsFileUrl
        ? <b>Product Disclosure Statement</b>
        : (
          <a href={pdsFileUrl} target="_blank" rel="noreferrer" onClick={handlePDSClick}>
            Product Disclosure Statement
          </a>
        )}
      &nbsp;for a full overview of fees and charges.
    </>
  );

  if (!methodology) {
    return placeholder;
  }

  return (
    <>
      <ExpandableContainer lines={lines} more="More" less={null}>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: methodology }} />
        <p>{placeholder}</p>
      </ExpandableContainer>
    </>
  );
};

export default function PerformanceFeeMethodology({ fundId, methodology, pdsFileUrl }) {
  const isMobile = useIsMobile();
  const isMobileOrTablet = useIsMobileOrTablet();
  const isXXLarge = useIsXXLarge();
  // eslint-disable-next-line no-nested-ternary
  const lines = isMobile || isXXLarge ? 4 : isMobileOrTablet ? 3 : 2;

  const componentToShow = buildComponentToShow(fundId, methodology, pdsFileUrl, lines);

  return (
    <Container>
      {componentToShow}
    </Container>
  );
}

PerformanceFeeMethodology.propTypes = {
  fundId: PropTypes.number.isRequired,
  methodology: PropTypes.string,
  pdsFileUrl: PropTypes.string,
};

PerformanceFeeMethodology.defaultProps = {
  methodology: null,
  pdsFileUrl: null,
};
